import { ViewFactory } from 'wdc-cube-react'

import { AccessAuditHeaderScope, AccessAuditScope } from '../aa_scopes'
import AccessAuditHeaderView from './aa-header'
import AccessAuditView from './aa_view'

export function registerViews(rv = ViewFactory.register) {
    rv(AccessAuditScope, AccessAuditView)
    rv(AccessAuditHeaderScope, AccessAuditHeaderView)
}
